var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.28958 13.6654C6.51643 13.6654 5.8335 13.0606 5.8335 12.2469V3.75052C5.8335 2.93683 6.51643 2.33203 7.28958 2.33203H12.7107C13.4839 2.33203 14.1668 2.93683 14.1668 3.75052V12.2469C14.1668 13.0606 13.4839 13.6654 12.7107 13.6654H7.28958Z",
  fill: "#5C7D98"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.8335 11.1098C1.8335 11.478 2.13197 11.7765 2.50016 11.7765C2.86835 11.7765 3.16683 11.478 3.16683 11.1098L3.16683 4.88759C3.16683 4.5194 2.86835 4.22092 2.50016 4.22092C2.13197 4.22092 1.8335 4.5194 1.8335 4.88759V11.1098Z",
  fill: "#5C7D98"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.8335 11.9987C3.8335 12.3669 4.13197 12.6654 4.50016 12.6654C4.86835 12.6654 5.16683 12.3669 5.16683 11.9987L5.16683 3.9987C5.16683 3.63051 4.86835 3.33203 4.50016 3.33203C4.13197 3.33203 3.8335 3.63051 3.8335 3.9987L3.8335 11.9987Z",
  fill: "#5C7D98"
})));
export default __webpack_public_path__ + "static/media/sequence.91db0162.svg";
export { SvgComponent as ReactComponent };